import React, { useState } from "react";
import axios from "axios";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { API } from "../../lib/store";
import Seo from "../Seo";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export function AdminLogin({ onAuth }) {
  const [password, setPassword] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API}/admin/login`, { password });
      const role = res.data.role || "admin";
      onAuth(res.data.token, role);
      toast.success(role === "staff" ? "Welcome! Staff mode — stock control only" : "Welcome back!");
    } catch {
      toast.error("Incorrect password");
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-28">
      <Seo title="Admin" noindex />
      <div className="bg-white border border-[#eee6d6] p-10 text-center">
        <Lock size={32} strokeWidth={1.3} className="mx-auto text-[#a8842c]" />
        <h1 className="font-heading text-2xl text-[#171310] mt-4">Admin Access</h1>
        <p className="text-sm text-[#8f8571] mt-2">Enter your admin or staff password.</p>
        <form onSubmit={submit} className="mt-7 space-y-3">
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="rounded-none border-[#d8cdb5] h-11 text-center" data-testid="admin-password-input" />
          <Button type="submit" className="w-full rounded-none bg-[#171310] hover:bg-[#3a2f1d] text-[#e9d9ac] tracking-[0.15em] uppercase text-xs h-11 transition-colors duration-300" data-testid="admin-login-btn">Unlock Dashboard</Button>
        </form>
      </div>
    </div>
  );
}
